<template>
  <div>
    <div class="row">
      <div class="col-md-9">
        <h4 style="font-weight: bold;color:#3d464c;">
          {{ $t($route.name) }}
          <span v-if="$route.params.id != undefined">№{{ $route.params.id }}</span>
        <button type="button" v-if="$route.params.id!=undefined && settedrule.change==true" @click="Change()"
          class="btn btn-primary change">{{$t('Ўзгартириш')}}</button>
        </h4>
      </div>
      <div class="col-md-3 end">
        <router-link class="btn btn-danger" :to="{ path: '/kassaorder/index' }">
          <button type="button" class="closebutton">
            <b-icon icon="x-lg"></b-icon>
          </button>
        </router-link>
      </div>
    </div>
    <div class="rowform">
       <div class="col-md-1 topheader">
        <span>
          <label for="">Факт №</label>
          <input :disabled="changedisabled" type="number" class="input100" v-model="datas.number">
        </span>
      </div>
      <div class="col-md-2 topheader">
        <span>
          <label for="">{{$t('Вақт')}}</label>
          <input type="datetime-local" class="input100" disabled="true" :value="SetDatetime(datas.datetime)">
        </span>
      </div>
      <div class="col-md-2 topheader">
        <span>
          <label>Склад</label>
            <v-select
              :clearable="false"
              class="form-control-sm required md-input"
              :options="skladlist"
            :disabled="skladhave"
              v-model="datas.sklad_id"
              :reduce="name => name.id"
              label="name"
            >
              <template #search="{ attributes, events }">
                <input
                  class="vs__search"
                  v-bind="attributes"
                  v-on="events"
                  aria-activedescendant="null"
                />
              </template>
              <template v-slot:no-options="{ search, searching }">
                <template v-if="searching">
                  <em
                    ><b>{{ search }}</b></em
                  >
                  {{ $t("бўйича маьлумот йўқ") }}
                </template>
                <em style="opacity: 0.5" v-else>Маьлумот йўқ</em>
              </template>
            </v-select>
        </span>
      </div>
      <div class="col-md-2 topheader">
        <span>
          <label>Сумма</label><br>
          {{ datas.summa | numFormat }}
        </span>
      </div>
      <div class="col-md-2 topheader">
        <span>
          <label>Доллар Сумма</label><br>
          {{ datas.dollar_summa | numFormat }}
        </span>
      </div>
      <div class="col-md-2 topheader">
        <span>
          <label for="">{{$t('Курс')}}</label>
          <input :disabled="changedisabled" type="text" class="input100" v-model="datas.dollar_rate">
        </span>
      </div>
    </div>
    <div class="table100percent">
      <md-card>
        <md-card-content>
          <table class="table table-bordered">
            <thead>
              <tr>
                <th class="column0">№</th>
                <th class="column3">Асос</th>
                <th class="column3">Тўлов тури</th>
                <th class="column3">Тури</th>
                <th class="column2">Сумма</th>
                <th class="column3">Комментарий</th>
                <th class="column0"></th>
              </tr>
            </thead>
            <tbody style="overflow: hidden;">
              <div style="overflow-y: scroll;height: 62vh!important;"
              >
                <tr
                  v-for="(item, index) in datas.kassa_order_table"
                  :key="index"
                >
                  <td class="column0">{{ index + 1 }}</td>
                  <td class="column3">
                    <v-select :disabled="changedisabled"
                      :clearable="false"
                      class="form-control-sm required"
                      :options="baselist"
                      v-model="item.base_id"
                      :reduce="name => name.id"
                      label="name"
                      required="true"
                    >
                      <template #list-footer>
                        <li style="text-align: center;font-weight:bold;">
                          f4 {{ $t("умумий рўйхат") }}
                        </li>
                      </template>
                      <template #open-indicator="{ attributes }">
                        <span v-bind="attributes"></span>
                        <button
                        :disabled="changedisabled"
                          type="button"
                          class="modallist"
                          @click="Selectbase(index)"
                          v-b-modal.modal-baselist
                        >
                          <b-icon icon="three-dots"></b-icon>
                        </button>
                      </template>
                      <template #selected-option="{ name }">
                        <div>
                          {{ name }}
                        </div>
                      </template>
                      <template v-slot:no-options="{ search, searching }">
                        <template v-if="searching">
                          <em
                            ><b>{{ search }}</b></em
                          >
                          бўйича маьлумот йўқ
                          <button
                            type="button"
                            @click="
                              base.name = search;
                              Selectbase(index);
                            "
                            class="pluss"
                            v-b-modal.modal-base
                          >
                            +(ins)
                          </button>
                        </template>
                        <em style="opacity: 0.5;" v-else>Маьлумот йўқ</em>
                      </template>
                      <template #search="{ search, searching }">
                        <template v-if="searching">
                          <em
                            ><b>{{ search }}</b></em
                          >
                          <input
                            class="vs__search"
                            v-bind="attributes"
                            v-on="events"
                          />
                        </template>
                      </template>
                    </v-select>
                  </td>
                  <td class="column3">
                    <v-select
                    :disabled="changedisabled"
                      :clearable="false"
                      class="form-control-sm required"
                      :options="paytypelist"
                      v-model="item.pay_type_id"
                      @input="Summa()"
                      :reduce="name => name.id"
                      label="name"
                      required="true"
                    >
                    </v-select>
                  </td>
                  <td class="column3">
                    <v-select
                    :disabled="changedisabled"
                      :clearable="false"
                      class="form-control-sm required"
                      :options="typelist"
                      v-model="item.type"
                      @input="Summa()"
                      :reduce="name => name.id"
                      label="name"
                      required="true"
                    ></v-select>
                  </td>
                  <td class="column2">
                    <vue-numeric
                    :disabled="changedisabled"
                      separator="space"
                      v-model="item.summa"
                      @change="Summa()"
                      style="text-align: right;"
                      class="table-input"
                      v-bind:precision="2"
                    ></vue-numeric>
                  </td>
                  <td class="column3">
                    <input
                    :disabled="changedisabled"
                      v-model="item.comment"
                      style="width:100%"
                      class="table-input"
                    />
                  </td>
                  <td class="column0">
                    <a v-if="changedisabled==false"
                      href="javascript:void(0)"
                      class="circul trash"
                      @click="Trashitem(index)"
                    >
                      <b-icon icon="trash"></b-icon>
                    </a>
                  </td>
                </tr>
              </div>
            </tbody>
          </table>
        </md-card-content>
      </md-card>
    </div>
    <div class="row">
      <div class="col-md-12 end formbottom">
        <button v-if="changedisabled==false" class="addrow btn btn-primary" type="button" @click="Addtable()">
          <b-icon icon="plus-lg"></b-icon><sup>F1</sup>
        </button>
        <button :disabled="changedisabled" class="btn btn-success" type="button" @click="Savedokument('save')">
          {{ $t("Сақлаш") }}
        </button>
        <button :disabled="changedisabled" type="button" class="mybtn btn saved" @click="Savedokument()">
          {{ $t("Сақлаш ва беркитиш") }} <sup>crl+enter</sup>
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import $ from "jquery";
import { print } from "../../components/mixins/print.js";
export default {
  name: "KassaorderForm",
  mixins: [print],
  data() {
    return {
      typelist: [
        { id: false, name: "Чиқим" },
        { id: true, name: "Кирим" }
      ],
      sklad: "",
      paytype: "",
      base: "",
      skladlist: [],
      paytypelist: [],
      baselist: []
    };
  },
  props: ["datas", "errors"],
  created() {
    let self = this;
    self.$root.$refs.order = self;
    self.$root.$on("skladone", function(getdata) {
      self.sklad = getdata;
    });
    self.$root.$on("skladall", function(getdata) {
      self.skladlist = getdata;
    });
    self.$root.$on("paytypeone", function(getdata) {
      self.paytype = getdata;
    });
    self.$root.$on("paytypeall", function(getdata) {
      self.paytypelist = getdata;
    });
    self.$root.$on("baseone", function(getdata) {
      self.base = getdata;
    });
    self.$root.$on("baseall", function(getdata) {
      self.baselist = getdata;
    });
  },
  mounted: function() {
    let self = this;
    setTimeout(() => {
      self.Focus();
      self.SetRule('/kassaorder/index');
      // self.datas.datetime=self.SetDatetime(self.datas.datetime);
    }, 100);
  },
  methods: {
    Summa() {
      this.datas.summa = 0;
      this.datas.dollar_summa = 0;
      let self = this;
      this.datas.kassa_order_table.forEach(function(key, value) {
        if(key.pay_type_id==3){
          if(key.type==true){
            self.datas.dollar_summa += parseFloat(key.summa);  
          }else{
            self.datas.dollar_summa -= parseFloat(key.summa);  
          }
        }else{
          if(key.type==true){
            self.datas.summa += parseFloat(key.summa);  
          }else{
            self.datas.summa -= parseFloat(key.summa);  
          }
        }
      });
    },
    Focus() {
      $(".vs__search")
        .eq(1)
        .focus();
    },
    Selectbase(index) {
      this.$store.state.selected_index = index;
    },
    Selectpaytype(index) {
      this.$root.$emit("tableselect", index);
    },
    Addtable() {
        this.datas.kassa_order_table.push({
          base_id: 0,
          summa: 0,
          pay_type_id: 0,
          type: false,
          comment: ""
        });
      this.Tablefocus();
    },
    Addtableindex(index) {
      if (this.datas.kassa_order_table.length == index + 1) {
        this.datas.kassa_order_table.push({
          base_id: 0,
          summa: 0,
          pay_type_id: 0,
          type: false,
          comment: ""
        });
      }
    },
    Trashitem(index) {
      const answer = window.confirm(this.$t("Malumotlar ochirilsinmi?"));
      if (answer) {
        this.datas.kassa_order_table.splice(index, 1);
        this.Summa();
      }
    },
    Savedokument(type='default') {
      let self = this;
            // if(self.rule.change==true){
      if (this.$route.path == "/kassaorder/create") {
        var methods = "post";
        var action = "api/v1/kassa-order";
      } else {
        var methods = "patch";
        var action = "api/v1/kassa-order/id/" + self.$route.params.id;
      }
      //  self.datas.datetime = new Date(self.datas.datetime)
        // .valueOf()
        // .toString()
        // .slice(0, 10);
      axios({
        method: methods,
        url: action,
        data: self.datas
      }).then(function(response) {
        self.$store.state.saved = null;
        if(type=='save'){
          self.$router.push({ path: "/kassaorder/update/" + response.data.id });
        }else{
        self.$router.push({ name: "Кассовий ордер" });
        }
      });
    //    } else{
    //       self.$store.state.errors=self.$t('Sizdan bunday xuquq mavjud emas');
    // }
    }
  }
};
</script>

<style lang="scss" scoped>
.md-dialog .md-dialog-container {
  max-width: 768px;
}
</style>
